import React, {useState, useEffect, useRef} from 'react';
import {Map, View} from 'ol';
import TitleLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import {circular} from 'ol/geom/Polygon';
import {fromLonLat} from 'ol/proj';
import {Interaction, MouseWheelZoom} from 'ol/interaction';
import {Circle as CircleStyle, Fill, Stroke, Style, Image, Icon, Text} from 'ol/style';
import {defaults as defaultInteractions} from 'ol/interaction';
import FillImage from './images/Fill.svg';

const MapWrapper = ({latitude, longitude, accuracy}) => {
  const [map, setMap] = useState();
  const mapElement = useRef();
  const mapRef = useRef();

  mapRef.current = map;

  useEffect(() => {
    const coords = [longitude, latitude];
    const source = new VectorSource();
    const layer = new VectorLayer({
      source: source,
    });

    const initMap = new Map({
      target: mapElement.current,
      layers: [
        new TitleLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: fromLonLat(coords),
        zoom: 15,
      }),
      interactions: defaultInteractions({
        onFocusOnly: true,
        dragPan: false,
        mouseWheelZoom: false,
        doubleClickZoom: false,
      }),
    });
    //initMap.setSize([200, 200]);

    const accuracyPoint = circular(coords, accuracy);
    var circularPoint = new Feature(accuracyPoint.transform('EPSG:4326', initMap.getView().getProjection()));
    var currentPoint = new Feature(new Point(fromLonLat(coords)));
    currentPoint.setStyle(
      new Style({
        image: new Icon({
          crossOrigin: 'anonymous',
          src: FillImage,
        }),
      })
    );
    source.addFeatures([circularPoint, currentPoint]);
    initMap.addLayer(layer);
    initMap.getInteractions().forEach((interaction) => {
      if (interaction instanceof MouseWheelZoom) {
        interaction.setActive(false);
      }
    }, this);
    if (!source.isEmpty()) {
      initMap.getView().fit(source.getExtent(), {
        maxZoom: 15,
        duration: 2,
      });
    }
    initMap.setSize([400, 400]);
    initMap.updateSize();
    setMap(initMap);
  }, []);

  return <div ref={mapElement} className='map-wrapper-container' />;
};
export default MapWrapper;
